import { ArrowLeft, ArrowRight, ArrowUpRight, Plus } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
const categories = [{
  label: "SEMUA",
  active: true
}, {
  label: "NASIONAL",
  active: false
}, {
  label: "DAERAH",
  active: false
}, {
  label: "OPINI",
  active: false
}, {
  label: "KEGIATAN",
  active: false
}, {
  label: "SOSIAL",
  active: false
}];
const fallbackPosts = [{
  id: "f1",
  title: "Konsolidasi Organisasi di Tingkat Wilayah",
  excerpt: "Langkah strategis memperkuat struktur organisasi untuk memastikan setiap kader memahami visi dan misi organisasi dalam pengabdian masyarakat.",
  category: "NASIONAL",
  date: "2024.11.03",
  author: "REDAKSI",
  readTime: "6 MENIT BACA",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/konsolidasi_organisasi.png",
  height: "tall"
}, {
  id: "f2",
  title: "Peluncuran Program Bakti Sosial Pemuda",
  excerpt: "Kegiatan nyata dalam membantu masyarakat yang membutuhkan melalui aksi sosial yang tersebar di berbagai pelosok daerah.",
  category: "KEGIATAN",
  date: "2024.10.28",
  author: "HUMAS",
  readTime: "4 MENIT BACA",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/bakti_sosial.png",
  height: "short"
}, {
  id: "f3",
  title: "Analisis Peran Pemuda dalam Pembangunan Bangsa",
  excerpt: "Sebuah tinjauan mendalam mengenai bagaimana generasi muda dapat berkontribusi aktif dalam menjaga kedaulatan dan kemajuan negara.",
  category: "OPINI",
  date: "2024.10.21",
  author: "PENGURUS",
  readTime: "8 MENIT BACA",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/pemuda_bangsa.png",
  height: "medium"
}, {
  id: "f4",
  title: "Pentingnya Pendidikan Karakter bagi Kader",
  excerpt: "Membangun mentalitas yang tangguh dan berintegritas tinggi melalui serangkaian pelatihan kepemimpinan yang berkelanjutan.",
  category: "SOSIAL",
  date: "2024.10.15",
  author: "REDAKSI",
  readTime: "5 MENIT BACA",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/pendidikan_karakter.webp",
  height: "medium"
}, {
  id: "f5",
  title: "Update Struktur Organisasi Terbaru",
  excerpt: "Pengumuman resmi mengenai perubahan dan penyesuaian struktur kepengurusan untuk periode mendatang.",
  category: "DAERAH",
  date: "2024.10.08",
  author: "SEKRETARIAT",
  readTime: "3 MENIT BACA",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/struktur_organisasi.png",
  height: "short"
}, {
  id: "f6",
  title: "Sinergi Antar Lembaga dalam Menjaga Keamanan",
  excerpt: "Pentingnya kolaborasi lintas sektor untuk menciptakan lingkungan yang kondusif dan aman bagi seluruh lapisan masyarakat.",
  category: "NASIONAL",
  date: "2024.10.01",
  author: "PENGURUS",
  readTime: "7 MENIT BACA",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/sinergi_lembaga.png",
  height: "tall"
}];
function JournalGrid() {
  const {
    posts,
    loading,
    error,
    currentPage,
    totalPages,
    hasNext,
    hasPrev,
    nextPage,
    prevPage,
    isRefetching
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="border border-border bg-card animate-pulse">
            <div className="aspect-[4/5] bg-muted/40" />
            <div className="p-6 space-y-3">
              <div className="h-4 w-3/4 bg-muted/40" />
              <div className="h-3 w-full bg-muted/30" />
              <div className="h-3 w-2/3 bg-muted/30" />
            </div>
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="border border-border p-12 text-center">
        <p className="text-sm text-muted-foreground font-mono">// ERROR_MEMUAT_DATA</p>
      </div>;
  }
  const displayPosts = posts.length > 0 ? posts : fallbackPosts.map(p => ({
    id: p.id,
    title: p.title,
    excerpt: p.excerpt,
    link: "#",
    date: p.date,
    featuredImage: p.image,
    categories: [{
      id: 1,
      name: p.category,
      slug: "",
      taxonomy: "category"
    }],
    author: {
      id: 1,
      name: p.author
    },
    customFields: {
      readTime: p.readTime,
      height: p.height
    }
  }));
  const formatDate = (d?: string) => {
    if (!d) return "";
    try {
      const date = new Date(d);
      if (!isNaN(date.getTime())) {
        return `${date.getFullYear()}.${String(date.getMonth() + 1).padStart(2, "0")}.${String(date.getDate()).padStart(2, "0")}`;
      }
    } catch {}
    return d;
  };
  return <>
      <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
        {displayPosts.map((post, i) => {
        const heights = ["aspect-[4/5]", "aspect-[16/10]", "aspect-[4/5]", "aspect-[16/11]", "aspect-[16/10]", "aspect-[4/5]"];
        const aspect = heights[i % heights.length];
        const category = post.categories?.[0]?.name || "BERITA";
        const authorName = typeof post.author === "object" ? post.author?.name : post.author;
        const readTime = (post as any).customFields?.readTime || "5 MENIT BACA";
        return <article key={post.id} data-index={i} className="group break-inside-avoid mb-6 border border-border bg-card hover:border-orange-600 transition-all duration-300 relative overflow-hidden">
              <div className="absolute -top-px -left-px z-20 text-orange-600">
                <Plus className="w-3 h-3" strokeWidth={1.5} />
              </div>
              <div className="absolute -top-px -right-px z-20 text-orange-600">
                <Plus className="w-3 h-3" strokeWidth={1.5} />
              </div>

              <Link to={post.link || "#"} className="block">
                <div className={`relative ${aspect} overflow-hidden bg-muted`}>
                  {post.featuredImage && <img src={post.featuredImage} alt={post.title} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" />}
                  <div className="absolute top-3 left-3">
                    <Badge variant="default" className="font-mono text-[10px] tracking-wider bg-background/80 text-orange-600 border border-orange-600/40 backdrop-blur-sm">
                      {category.toUpperCase()}
                    </Badge>
                  </div>
                  <div className="absolute top-3 right-3">
                    <span className="font-mono text-[10px] tracking-wider text-foreground bg-background/80 px-2 py-1 backdrop-blur-sm border border-border">
                      {formatDate(post.date)}
                    </span>
                  </div>
                </div>

                <div className="p-6">
                  <h3 className="font-default text-[22px] font-medium leading-snug text-foreground group-hover:text-orange-600 transition-colors duration-300">
                    {post.title}
                  </h3>
                  {post.excerpt && <p className="mt-3 text-sm text-muted-foreground leading-relaxed line-clamp-3 font-default">
                      {post.excerpt.replace(/<[^>]*>/g, "")}
                    </p>}

                  <div className="mt-5 pt-4 border-t border-border flex items-center justify-between">
                    <span className="font-mono text-[11px] tracking-wider text-muted-foreground uppercase">
                      {authorName || "ADMIN"} · {readTime}
                    </span>
                    <span className="font-mono text-[11px] tracking-wider text-orange-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center gap-1">
                      <ArrowUpRight className="w-3 h-3" strokeWidth={2} />
                      BACA
                    </span>
                  </div>
                </div>
              </Link>
            </article>;
      })}
      </div>

      {(posts.length > 0 || totalPages > 1) && <div className="mt-16 pt-8 border-t border-border flex items-center justify-between">
          <div className="font-mono text-xs tracking-wider text-muted-foreground">
            <span className="text-orange-600">{String(currentPage).padStart(2, "0")}</span>
            <span className="mx-2 text-border">/</span>
            <span>{String(Math.max(totalPages, 1)).padStart(2, "0")}</span>
          </div>

          <div className="flex items-center gap-2">
            <Button variant="outline" size="icon" onClick={prevPage} disabled={!hasPrev || isRefetching} className="border-border hover:border-orange-600 hover:text-orange-600 hover:bg-transparent disabled:opacity-30" aria-label="Halaman sebelumnya">
              <ArrowLeft className="w-4 h-4" strokeWidth={1.5} />
            </Button>
            <Button variant="outline" size="icon" onClick={nextPage} disabled={!hasNext || isRefetching} className="border-border hover:border-orange-600 hover:text-orange-600 hover:bg-transparent disabled:opacity-30" aria-label="Halaman berikutnya">
              <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
            </Button>
          </div>
        </div>}
    </>;
}
export default function NewsGrid() {
  const wp_query_params = {
    post_type: "post",
    per_page: 9,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="4629" id="news-grid" className="bg-background text-foreground pt-24 pb-32 px-4 sm:px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16">
          <div className="flex items-center gap-2 mb-8">
            <span className="font-mono text-xs tracking-wider text-orange-600">
              // BERITA_TERKINI — 47 ARTIKEL
            </span>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
            <div className="lg:col-span-7">
              <h1 className="font-default text-5xl sm:text-6xl lg:text-[6rem] leading-[0.95] tracking-tight text-foreground">
                Berita.
              </h1>
            </div>
            <div className="lg:col-span-5">
              <p className="text-base text-muted-foreground leading-relaxed font-default max-w-md">
                Informasi terbaru, kegiatan organisasi, dan wawasan kebangsaan dari keluarga besar kami.
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-b border-border py-5 mb-12 -mx-4 sm:-mx-6 lg:-mx-12 px-4 sm:px-6 lg:px-12">
          <div className="flex items-center gap-2 sm:gap-3 overflow-x-auto scrollbar-hide">
            <span className="font-mono text-[10px] tracking-widest text-muted-foreground whitespace-nowrap mr-2 hidden sm:inline">
              FILTER:
            </span>
            {categories.map((cat, i) => <Button key={cat.label} data-index={i} variant={cat.active ? "default" : "outline"} size="sm" className={cat.active ? "h-8 px-4 font-mono text-[11px] tracking-wider bg-orange-600 text-white hover:bg-orange-700 border-0 whitespace-nowrap" : "h-8 px-4 font-mono text-[11px] tracking-wider border-border text-muted-foreground hover:text-orange-600 hover:border-orange-600 bg-transparent hover:bg-transparent whitespace-nowrap"}>
                {cat.label}
              </Button>)}
          </div>
        </div>

        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 9,
        orderby: "date",
        order: "desc"
      }}>
          <JournalGrid />
        </PostsProvider>
      </div>
    </section>;
}